export const path = "/top-secret";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "PROYECTO TOP SECRET",
  section: "ALUNA",
  group: null,
  order: 99,
  roles: ["Authenticated"],
};
